// This file is automatically generated. Do not edit manually.

import { PartConfigurationBomLineInspectionDto } from "src/api/generated/erp/configurator/api/partConfigurationBomLineInspectionDto";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationBomPricesApi {
	export async function getBomPricesByBomLineGroupRecursively(args: {
		partConfigurationId: number;
	}): Promise<Array<PartConfigurationBomPricesApi_BomLineGroupPricesDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/bom/prices/getBomPricesByBomLineGroupRecursively",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
			},
		});
		return response as Array<PartConfigurationBomPricesApi_BomLineGroupPricesDto>;
	}

	export async function getBomLinesInGroupRecursively(args: {
		partConfigurationId: number;
		bomLineGroupId: number;
	}): Promise<Array<PartConfigurationBomLineInspectionDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/bom/prices/getBomLinesInGroupRecursively",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
				bomLineGroupId: args.bomLineGroupId,
			},
		});
		return response as Array<PartConfigurationBomLineInspectionDto>;
	}
}

export interface PartConfigurationBomPricesApi_BomLineGroupPricesDto {
	bomLineGroupId: number;
	bomLineGroupName: string;
	totalCost: number;
	totalCostInSellingCurrency: number | null | undefined;
	totalPriceInSellingCurrency: number;
}
